/*
 * One post on the Updates feed, as an admin board lists it.
 *
 * Two boards ask about the same rows from opposite ends: the abuse case asks
 * "what has this account put on the feed", the events board asks "what has
 * been posted about this space". The shape is the one Postgres returns in
 * both cases, so it lives here rather than once per board.
 *
 * Mirrors AuthorPost in firebaseFunctions/functions/src/data/pg/posts.data.ts.
 */

/** Who wrote it. Null on a list that is already about one account. */
export interface PostAuthorDto {
  uid: string;
  name: string;
  email: string | null;
  profileImageUrl: string | null;
}

export interface FeedPostDto {
  id: string;
  type: string;
  freeText: string | null;
  eventVenue: string | null;
  eventName: string | null;
  destinationName: string | null;
  images: string[];
  likesCount: number;
  viewedCount: number;
  createdAt: string | null;
  author: PostAuthorDto | null;
}

/**
 * One line that says what a post is, for a list row or a confirm dialog.
 *
 * A post with no text is the one worth naming out loud: an image-only post
 * reads as an empty row otherwise, and "(no text)" is the difference between
 * a missing field and a post that really is just a picture.
 * @param p the post
 */
export function feedPostSummary(p: FeedPostDto): string {
  const where = p.destinationName || p.eventName || '';
  const text = (p.freeText || '').trim();
  return [text ? `"${text}"` : '(no text)', where].filter(Boolean).join(' — ');
}
